import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { DataGrid } from '@mui/x-data-grid'
import { useTheme } from '../../../../../components/mui/Styles/index'
import { Grid, Paper } from '../../../../../components/mui/Core/index'
import LinkButton from '../../../../../components/LinkButton/link-button'
import { setSelectedCustomerGroup } from '../../../CustomerGroup/customer-group-slice'

export function ItemSpecialPricingTable() {
  const theme = useTheme()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const itemSpecialPricingSummary = useSelector(
    (state) => state.itemSpecialPricing.itemSpecialPricingSummary,
  )
  const isFetchingItemSpecialPricingSummary = useSelector(
    (state) => state.itemSpecialPricing.isFetchingItemSpecialPricingSummary,
  )

  const handleCustomerGroupLinkClick = (customerGroup) => {
    dispatch(setSelectedCustomerGroup(customerGroup))
    navigate('/customerGroup')
  }
  const gridStyle = {
    backgroundColor: theme.palette.common.white,
    minHeight: '160px',
    height: isFetchingItemSpecialPricingSummary ? '400px' : 'auto',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: theme.palette.grey[300],
  }

  const rows = itemSpecialPricingSummary.map((row) => ({
    id: row.customerGroupNumber,
    customerGroupName: row.customerGroupName,
    price: row.price,
    isGroup: row.isGroup,
  }))

  const columns = [
    {
      field: 'customerGroupName',
      headerName: 'Group/Customer',
      sortable: false,
      flex: 1,
      minWidth: 200,
      renderCell: (cellValues) => {
        const customerGroup = cellValues.row?.customerGroupName
        if (cellValues.row?.isGroup === 1) {
          return (
            <LinkButton
              handleLinkClick={() => {
                handleCustomerGroupLinkClick(cellValues.row)
              }}
              linkText={cellValues.row.customerGroupName}
            />
          )
        }
        return customerGroup
      },
    },
    {
      type: 'number',
      field: 'price',
      headerName: 'Unit Price',
      sortable: false,
      flex: 1,
      minWidth: 200,
      align: 'right',
      headerAlign: 'right',
      valueFormatter: (value) => {
        const price = value
        return `$${price}`
      },
    },
  ]

  return (
    <Grid sx={{ paddingTop: 3 }}>
      <Paper>
        <DataGrid
          sx={gridStyle}
          rows={rows}
          columns={columns}
          loading={isFetchingItemSpecialPricingSummary}
          pageSizeOptions={[25, 50]}
          disableRowSelectionOnClick
          initialState={{
            pagination: {
              paginationModel: { pageSize: 25, page: 0 },
            },
          }}
          slotProps={{
            pagination: {
              component: 'div',
              showLastButton: true,
              showFirstButton: true,
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
        />
      </Paper>
    </Grid>
  )
}

export default ItemSpecialPricingTable
